export default "__VITE_ASSET__B8q5Njkx__"